import { render, staticRenderFns } from "./Preprensa.vue?vue&type=template&id=28e49c91&scoped=true&"
import script from "./Preprensa.vue?vue&type=script&lang=js&"
export * from "./Preprensa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e49c91",
  null
  
)

export default component.exports